<!-- AI Generated Template -->
<page-header [icon]="'fas fa-link'" [header]="'Links' | translate"
             [subHeader]="'List of content containing links' | translate">
             <page-header-content>
                <div class="p-1 pull-right">
                    <csv-export-button clsSize="py-2 px-3" clsMargin="mr-0" [exports]="exports"></csv-export-button>
                </div>
            </page-header-content>
</page-header>
<div class="card panel-monsido-card mt-1">
    <div class="card-body">
        <div class="px-4">
            <mon-spinner [loading]="loading">
                <table class="table table-hover table-fixed">
                    <thead>
                        <tr>
                          <th class="col-sm-44 col-md-44" translate>Type</th>
                          <th class="col-sm-4 col-md-4 text-right" translate>Total</th>
                        </tr>
                    </thead>
                    <tbody class="borderless">
                        <tr [ngClass]="{ 'active': type.subs }" *ngFor="let type of $any(types | keyvalue); let $index = index">
                            <td class="text-v-middle">
                                <button class="btn btn-border-radius btn-link pl-0"
                                        type="button"
                                        [attr.aria-label]="'Go to overlay with details' | translate"
                                        [ngClass]="{'text-dark-grey': type.value.parent, 'text-grey': type.value.total === 0}"
                                        [disabled]="type.value.total === 0"
                                        (click)="openPages(type.value)">
                                    <span class="fa-lg mr-2" aria-hidden="true" [ngClass]="type.value.icon"></span>
                                    {{ type.value.name }}
                                </button>
                            </td>
                            <td class="text-v-middle text-right">
                                <button class="btn btn-border-radius btn-link"
                                        type="button"
                                        [disabled]="type.value.total === 0"
                                        [ngClass]="{'text-grey': type.value.total === 0}"
                                        (click)="openPages(type.value)"
                                        role="button"
                                        [attr.aria-label]="'Go to overlay with details' | translate">
                                        {{ type.value.total}}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </mon-spinner>
        </div>
    </div>
</div>
